module.exports = __webpack_public_path__ + "vi.9089b8e3.svg";